var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 160,
    viewBox: "0 0 169 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3218 158.377C47.448 158.626 42.4601 159.029 38.5282 159.202C36.1646 159.306 34.8037 159.075 34.0201 158.761C34.0215 158.849 34.0238 158.933 34.0273 159.011C34.0459 159.424 34.3821 159.755 34.8 159.779C42.2298 160.193 48.1387 159.922 50.2423 159.794C50.6772 159.768 50.9364 159.295 50.714 158.924C50.6029 158.739 50.4683 158.557 50.3218 158.377Z",
    fill: "#6264EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5284 159.202C42.4605 159.029 47.4481 158.626 50.3219 158.377C47.4964 154.911 38.5284 152.574 38.5284 152.574H35.9956C34.2534 155.085 34.0013 157.476 34.0202 158.761C34.8039 159.075 36.1647 159.306 38.5284 159.202Z",
    fill: "url(#paint0_linear_2520_2543)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5687 148.439L35.8058 153.129C35.8315 153.637 36.2117 154.064 36.7204 154.137C37.2266 154.209 37.9043 154.219 38.623 153.979C39.0652 153.832 39.3934 153.459 39.475 153.005L40.294 148.439H35.5687Z",
    fill: "url(#paint1_linear_2520_2543)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66984 159.167C1.4235 158.994 0.859777 158.346 0.623389 157.654C0.621797 157.66 0.620209 157.666 0.618616 157.673C0.43531 158.403 0.860307 159.159 1.71013 159.519C2.73725 159.954 3.86027 160.028 4.73221 159.992C5.6675 159.954 6.52617 159.567 6.99806 158.947L7.00513 158.938C6.06613 159.403 4.74813 159.457 2.66984 159.167Z",
    fill: "#6A6CF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54526 148.409H6.45652C3.27485 148.344 1.27688 155.055 0.622925 157.654C0.859312 158.346 1.42321 158.993 2.66937 159.167C4.74784 159.457 6.06566 159.402 7.00467 158.938C8.7236 156.676 9.57573 153.363 9.98551 151.429C10.4512 149.231 8.54526 148.409 8.54526 148.409Z",
    fill: "url(#paint2_linear_2520_2543)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72569 144.056L5.56569 148.669C5.42344 149.234 5.69416 149.819 6.21718 150.088C6.86601 150.421 7.77952 150.771 8.61908 150.669C9.01401 150.622 9.34187 150.344 9.47245 149.972L11.1753 145.118L6.72569 144.056Z",
    fill: "url(#paint3_linear_2520_2543)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34192 145.388C6.78501 146.668 11.4788 146.837 11.4788 146.837C28.3866 106.257 35.3031 100.492 35.3031 100.492C32.8617 115.809 34.9094 149.719 34.9094 149.719C37.6995 150.95 41.2966 149.719 41.2966 149.719C41.5233 124.643 45.3775 102.774 49.9308 85.5333C38.5032 85.2763 32.4259 81.3659 30.4416 79.7964C20.916 95.1538 5.34192 145.388 5.34192 145.388Z",
    fill: "url(#paint4_linear_2520_2543)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.344 33.1286C31.181 43.9178 31.9563 63.2283 32.4655 72.0364C32.6087 74.5121 30.8804 77.9441 29.4834 80.2855C29.2642 80.6526 29.3996 81.1229 29.78 81.3184C32.1186 82.5204 40.0416 86.2456 49.2242 86.709C49.8364 86.74 50.3832 86.3229 50.5419 85.7307C57.3532 60.2979 65.2648 44.0461 65.2648 44.0461C56.5301 30.0978 33.344 33.1286 33.344 33.1286Z",
    fill: "#3360F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7764 64.0939C20.4712 69.1201 22.524 74.6023 26.6304 80.4256L28.1913 79.1531C28.1913 79.1531 26.3892 71.8419 27.4137 63.5445C24.8808 63.0501 21.889 63.5595 19.7764 64.0939Z",
    fill: "#3360F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7601 46.4416L33.3442 33.1293C33.3442 33.1293 17.2021 45.468 19.7767 64.0941C21.8894 63.5597 24.881 63.0503 27.4142 63.5445C28.1522 57.5672 30.3565 51.0783 35.7601 46.4416Z",
    fill: "#3360F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2648 44.0469L59.0339 57.4658C60.0414 65.5672 64.3933 69.0702 69.086 70.4138C69.3787 66.7215 70.3122 63.7385 71.1785 61.6751C65.1828 55.4848 65.2648 44.0469 65.2648 44.0469Z",
    fill: "#3360F6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1782 61.6751C70.3119 63.7385 69.3782 66.7215 69.0858 70.4138C81.6054 75.2712 84.9177 65.8508 84.9177 65.8508L82.6039 65.4426C77.3786 65.993 73.7288 64.3086 71.1782 61.6751Z",
    fill: "#3360F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5241 27.4798L56.5162 38.5378C56.1783 39.78 54.8346 40.4471 53.6392 39.9692C52.3492 39.4534 50.7125 38.7496 49.3038 37.9889C47.7998 37.177 47.3293 35.2423 48.2812 33.823L54.5351 24.498L59.5241 27.4798Z",
    fill: "url(#paint5_linear_2520_2543)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6561 58.4505L13.5775 86.5041C10.3447 87.6807 8.79948 91.3616 10.2236 94.4932L10.4575 95.0073C11.7177 97.778 14.9924 98.9934 17.7549 97.7153L92.5973 63.0928L90.6561 58.4505Z",
    fill: "url(#paint6_linear_2520_2543)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M126.084 78.9385C147.098 78.9385 164.134 62.2104 164.134 41.5752C164.134 20.94 147.098 4.21191 126.084 4.21191C105.07 4.21191 88.0344 20.94 88.0344 41.5752C88.0344 62.2104 105.07 78.9385 126.084 78.9385Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.084 0.00012207C102.701 0.00012207 83.7454 18.614 83.7454 41.5752C83.7454 64.5366 102.701 83.1505 126.084 83.1505C149.468 83.1505 168.423 64.5366 168.423 41.5752C168.423 18.614 149.468 0.00012207 126.084 0.00012207ZM126.084 77.0432C106.136 77.0432 89.9647 61.1637 89.9647 41.5752C89.9647 21.9868 106.136 6.10726 126.084 6.10726C146.033 6.10726 162.204 21.9868 162.204 41.5752C162.204 61.1639 146.033 77.0432 126.084 77.0432Z",
    fill: "url(#paint7_linear_2520_2543)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 78.9312L34.8342 78.3374L37.9899 81.2464C37.9899 81.2464 37.2434 82.2785 34.9092 81.6852C32.5751 81.092 29.378 80.9465 29.378 80.9465C29.378 80.9465 26.1559 82.3992 26.1166 79.6811L27.5476 78.9312Z",
    fill: "url(#paint8_linear_2520_2543)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9896 67.5736C84.6197 68.066 86.7787 67.038 88.0999 66.3274C88.7438 65.9811 89.0557 65.2281 88.8345 64.5313C88.5166 63.5286 87.9868 62.2345 87.3341 62.0714C86.2512 61.8007 81.3929 65.5446 83.9896 67.5736Z",
    fill: "url(#paint9_linear_2520_2543)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1744 16.6242C60.1744 16.6242 62.664 22.3436 62.8312 25.3456C62.9985 28.3475 63.6453 30.2953 60.1744 30.8999C56.7032 31.5045 53.7794 29.7753 52.1952 26.7851C52.1952 26.7851 49.7132 22.1775 50.27 20.2905C50.8268 18.4033 60.1744 16.6242 60.1744 16.6242Z",
    fill: "url(#paint10_linear_2520_2543)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.381 24.635H53.8198C53.8198 24.635 52.0118 20.9266 53.6004 20.2751C55.1889 19.6235 61.4816 18.3403 62.8393 16.1076C64.1481 13.955 62.9808 11.1746 61.2345 10.3964C61.1239 10.3472 60.9936 10.3992 60.9372 10.5061L60.7925 10.7798C60.6934 10.9674 60.4165 10.9389 60.3576 10.7352C60.3016 10.542 60.0412 10.4999 59.9349 10.6707C59.5192 11.3384 58.3939 12.4241 55.3756 12.9813C51.0928 13.7716 48.2615 15.5051 48.1919 18.4649C48.1875 18.6524 47.987 18.7558 47.8269 18.6583C47.5107 18.4656 47.0047 18.3752 46.3284 18.9437C45.1525 19.9326 45.6336 22.4976 48.2116 24.6076C48.334 24.7079 48.3331 24.8992 48.2004 24.9855C47.7331 25.2898 47.0365 26.0137 48.8418 26.9785C50.6883 27.9657 51.7811 27.8579 52.1935 27.7524C52.3045 27.724 52.3791 27.6229 52.3721 27.5086L52.21 24.8857C52.2017 24.75 52.3094 24.6354 52.4453 24.6354H53.381V24.635Z",
    fill: "url(#paint11_linear_2520_2543)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4893 25.1844C53.4893 25.1844 52.5395 21.531 50.9015 22.5553C49.2635 23.5796 51.7514 26.6489 53.0684 26.7857L53.4893 25.1844Z",
    fill: "url(#paint12_linear_2520_2543)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.829 29.8474L123.113 19.5121C122.154 17.5328 119.833 16.7074 118.078 17.7209L109.071 22.921C107.408 23.8808 106.905 26.1221 107.947 27.927L114.683 38.5658L103.508 45.4532C101.742 46.473 101.088 48.6476 102.048 50.3102L106.07 57.2759C106.977 58.847 109.015 59.4127 110.75 58.5749L123.088 51.8412L129.225 61.534C130.267 63.3389 132.459 64.024 134.122 63.0641L141.088 59.0424C142.659 58.1354 143.208 56.069 142.35 54.2975L136.841 44.3353L149.977 37.1657C151.916 36.2297 152.706 33.9291 151.693 32.1737L146.493 23.1669C145.533 21.5043 143.323 20.9831 141.557 22.0029L128.829 29.8474Z",
    fill: "#E00000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2520_2543",
    x1: 34.0193,
    y1: 155.901,
    x2: 50.322,
    y2: 155.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2520_2543",
    x1: 35.5688,
    y1: 151.311,
    x2: 40.2941,
    y2: 151.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2520_2543",
    x1: 0.622748,
    y1: 153.877,
    x2: 10.0587,
    y2: 153.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2520_2543",
    x1: 5.52813,
    y1: 147.371,
    x2: 11.1753,
    y2: 147.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2520_2543",
    x1: 40.1924,
    y1: 89.846,
    x2: 5.11565,
    y2: 174.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E30DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2520_2543",
    x1: 53.6969,
    y1: 24.431,
    x2: 53.524,
    y2: 53.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2520_2543",
    x1: 9.69207,
    y1: 78.3371,
    x2: 92.5972,
    y2: 78.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2520_2543",
    x1: 83.7454,
    y1: 41.5754,
    x2: 168.423,
    y2: 41.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2520_2543",
    x1: 39.3389,
    y1: 74.021,
    x2: 19.2358,
    y2: 91.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2520_2543",
    x1: 98.2844,
    y1: 46.5658,
    x2: 92.4455,
    y2: 55.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2520_2543",
    x1: 53.734,
    y1: 12.7941,
    x2: 57.8035,
    y2: 27.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2520_2543",
    x1: 74.0345,
    y1: -2.0637,
    x2: 66.2493,
    y2: 5.89843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2520_2543",
    x1: 49.1023,
    y1: 14.0481,
    x2: 53.1718,
    y2: 29.0877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b083ade59fe73775612ac505bc4eec05.svg";
export { ForwardRef as ReactComponent };